export function englishToNepali(inputEnglishText) {
    if(inputEnglishText % 1 != 0){
       inputEnglishText=inputEnglishText.toString();
       let firstNumber=inputEnglishText.split('.')[0];
       let secondNumber=inputEnglishText.split('.')[1];
        return convertToNepali(firstNumber)+'.'+convertToNepali(secondNumber)
    } else return convertToNepali(inputEnglishText);

    function convertToNepali(number) {
        var strChars = parseInt(number);
        var mapArray = [
            "०",
            "१",
            "२",
            "३",
            "४",
            "५",
            "६",
            "७",
            "८",
            "९"
        ];

        if (strChars == 0)
            var outStr = "-";

        else
            outStr = "";

        while (strChars > 0) {
            var currentDigit = strChars % 10;
            strChars = parseInt(strChars / 10);
            outStr = mapArray[currentDigit] + outStr;
        }

        return outStr.trim();
    }

};


export function addCommas(number) {

    let unsignedNumber = number < 0 ? -number : number;
    let numberString = englishToNepali(unsignedNumber);

    let sb =numberString;

    let interval = 3;


    for (let i = numberString.length - 3; i > 0; i -= interval) {
        sb= sb.slice(0,i) + ',' + sb.slice(i, sb.length);
        interval = 2;
    }

    if (unsignedNumber !== number) {
        sb= '-' + sb;
    }

    return sb;
};